interface ModalElement {
  modalId?: string | number;
  modalTrigger?: string | undefined;
}

export const Modal = (modalElements: NodeListOf<HTMLElement>): void => {
  // Set pro sledování, které "modalTrigger" už byly zaregistrovány
  const registeredTriggers = new Set<string>();

  modalElements.forEach((modal) => {
    // hack for Mac browsers (přesun do body)
    document.body.appendChild(modal);

    const { modalTrigger }: ModalElement = modal.dataset;

    // Pokud není modalTrigger, necháme ho být (nemá triggery)
    if (!modalTrigger) {
      attachCloseHandlers(modal);
      return;
    }

    // Pokud už jsme pro tento konkrétní selector připojili jiný modal,
    // přeskočíme navazování listenerů u této instance.
    if (registeredTriggers.has(modalTrigger)) {
      // Neprovádíme .return; — přidáme jen zavírací handlery pro tento modal,
      // ale neregistrujeme triggery (vyhneme se duplicitnímu otevírání).
      attachCloseHandlers(modal);
      return;
    }

    // Najdeme všechny trigger elementy pro tento selector
    const triggerElements: NodeListOf<HTMLElement> = document.querySelectorAll(modalTrigger);
    if (!triggerElements.length) {
      // nejsou žádné triggery na stránce -> nic neinicializujeme, ale registrované to neoznačujeme
      attachCloseHandlers(modal);
      return;
    }

    // Označíme tento selector jako registrovaný (tedy další modaly se stejným selektorem přeskočí)
    registeredTriggers.add(modalTrigger);

    // Přidáme click listenery ke všem triggerům (více triggerů otevírá JEDEN modal)
    triggerElements.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        // Zobrazit modal
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
      });
    });

    // Přidej zavírací logiku
    attachCloseHandlers(modal);
  });

  // Zavřít na stisk klávesy Escape
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      // Najít všechny otevřené modaly a zavřít je
      const openedModals = document.querySelectorAll('[data-modal][style*="display: block"]');
      openedModals.forEach((openedModal) => {
        (openedModal as HTMLElement).style.display = 'none';
      });
      document.body.style.overflow = 'visible';
    }
  });

  // Pomocná funkce pro přidání close handlerů (klik mimo + tlačítka)
  function attachCloseHandlers(modalNode: HTMLElement) {
    document.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;
        const targetEl = event.target as HTMLElement;

        // Pokud klik byl přímo na element s data-modal a tento modal je otevřený
        if (
          targetEl.hasAttribute('data-modal') &&
          (targetEl as HTMLElement).style.display === 'block'
        ) {
          (targetEl as HTMLElement).style.display = 'none';
          document.body.style.overflow = 'visible';
        }
      },
      true // capture: true - aby chytal událost dříve než jiné listenery
    );

    // Tlačítko/a 'Zavřít' uvnitř modalu
    const buttonsClose: NodeListOf<HTMLElement> = modalNode.querySelectorAll('[data-modal-close]');
    if (buttonsClose.length) {
      buttonsClose.forEach((buttonClose) => {
        buttonClose.addEventListener('click', () => {
          modalNode.style.display = 'none';
          document.body.style.overflow = 'visible';
        });
      });
    }
  }
};

export default Modal;
